import { render, staticRenderFns } from "./ProductAssignments.vue?vue&type=template&id=d3d824ee&scoped=true&"
import script from "./ProductAssignments.vue?vue&type=script&lang=js&"
export * from "./ProductAssignments.vue?vue&type=script&lang=js&"
import style0 from "./ProductAssignments.vue?vue&type=style&index=0&id=d3d824ee&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d824ee",
  null
  
)

export default component.exports